import { render, staticRenderFns } from "./DashboardViewEditingVisibleFields.vue?vue&type=template&id=039cd2be"
import script from "./DashboardViewEditingVisibleFields.vue?vue&type=script&lang=js"
export * from "./DashboardViewEditingVisibleFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports